module.exports = __webpack_public_path__ + "apple-touch-icon.d8ff4845.png";